<template>
  <div class="welcome">
    
    <login v-if="!loggedIn" />
    <snippet :name="homeMessageKey" />
  </div>
</template>

<script>
import Login from './Login';
import Snippet from './Snippet';

export default {
  name: 'Home',
  components: {
    Login,
    Snippet
  },
  computed: {
    loggedIn() {
      return this.$parent.loggedIn;
    },
    homeMessageKey() {
      return this.loggedIn? "admin__welcome_logged_in" : "admin__welcome_logged_out";
    }
  },
  methods: {
    setUser(user) {
      this.$parent.setUser(user);
    }
  }
}
</script>
